import React from "react";

function SelectableChecker({
  type = "checkbox",
  name,
  value,
  checked = false,
  onChange,
  isDisabled,
  id,
}: {
  type?: "checkbox" | "radio";
  name?: string;
  value?: string | number;
  checked?: boolean;
  onChange: (isChecked: boolean) => void;
  isDisabled?: boolean;
  id?: string;
}) {
  return (
    <span className="inline-flex shrink-0 items-center">
      <input
        id={id}
        className={`h-5 w-5 cursor-pointer border-slate-300 accent-action disabled:cursor-not-allowed disabled:opacity-50 ${
          type === "radio" ? "rounded-full" : "rounded-control"
        }`}
        type={type}
        name={name}
        value={value}
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        disabled={isDisabled}
      />
    </span>
  );
}

export default SelectableChecker;
